"use strict";

/**
* Реквизит типа «Выбор из справочника» и «Множественный выбор» для детальных разделов.
* 
* @class WebAccess.components.wrappers.form.requisites._details.Reference
* @extends WebAccess.components.wrappers.form.requisites.Reference
* @mixes WebAccess.components.wrappers.form.requisites._details.editModeMixin
* @private
*/
(function (global) {

  const Reference = global.Reference.extend([global._details.editModeMixin], {
    className: 'DetailReference',
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установить фильтрацию по реквизитам справочника.
    *
    * @method WebAccess.components.wrappers.form.requisites._details.Reference#setFilter
    * @return {WebAccess.components.wrappers.form.requisites._details.Reference} Текущий объект реквизита – Reference.
    * @since 5.2.0.1300
    */
    setFilter: function (filter, opt_refCode) {
      var me = this;
      me._filter = filter;

      if (me.isEditMode) {
        me._super(filter, opt_refCode);
      }

      if (opt_refCode) me._filters[opt_refCode] = filter;
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**    
    * Получить имена справочников для выборки.
    *
    * @method WebAccess.components.wrappers.form.requisites._details.Reference#getReferences
    * @since 5.2.0.1300
    * @return {object} Имена справочников для выборки.
    */
    getReferences: function () {
      var me = this;
      if (me.isEditMode) {
        return me._super();
      }
      return this._references;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установить выборку из указанных справочников.
    *
    * @method WebAccess.components.wrappers.form.requisites._details.Reference#setReferences
    * @param {object} references Информация о справочниках. Формат описания выборки:
    * {"ОРГ":{"Caption": "организации",...},"РАБ":{..}}}
    * @return {WebAccess.components.wrappers.form.requisites._details.Reference} Текущий объект реквизита – Reference.
    * @since 5.2.0.1300
    */
    setReferences: function (references) {
      var me = this;
      me._references = references;
      if (me.isEditMode) {
        me._super(references);
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить новый справочник к текущему списку справочников для выборки.
    *
    * @function WebAccess.components.wrappers.form.requisites._details.Reference#addReferences
    * @param {object} references Информация о справочниках. Формат описания выборки:
    * {"ОРГ":{"Caption": "организации",...},"РАБ":{..}}}
    * @return {WebAccess.components.wrappers.form.requisites._details.Reference} Текущий объект реквизита – Reference.
    * @since 5.2.0.1300
    */
    addReferences: function (references) {
      var me = this;
      $.extend(me._references, references);
      if (me.isEditMode) {
        me._super(references);
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Указать справочник, выбор из которого будет выполняться в первую очередь.
    *
    * @method WebAccess.components.wrappers.form.requisites._details.Reference#setMainReference
    * @param {string} referenceName Справочник, выбор из которого будет выполняться в первую очередь
    * @return {WebAccess.components.wrappers.form.requisites._details.Reference} Объект типа Reference.
    * @since 5.2.0.1300
    */
    setMainReference: function (referenceName) {
      var me = this;
      me._mainReference = referenceName;
      if (me.isEditMode) {
        me._super(referenceName);
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить справочник для выборки, из которого доступны последние и избранные объекты.
    *
    * @method WebAccess.components.wrappers.form.requisites._details.Reference#addLastObjectsPseudoReference
    * @param {LAST_REFERENCES} lastReferences Справочники, из которых будет выполняться выбор
    * @return {WebAccess.components.wrappers.form.requisites._details.Reference} Объект типа Reference.
    * @since 5.2.0.1300
    */
    addLastObjectsPseudoReference: function (lastReferences) {
      var me = this;
      me._addLastObjectsPseudoReference = true;
      me._lastReferences = lastReferences;
      if (me.isEditMode) {
        me._super(lastReferences);
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Удалить из списка выборки справочник, из которого доступны последние и избранные объекты. 
    *
    * @method WebAccess.components.wrappers.form.requisites._details.Reference#removeLastObjectsPseudoReference
    * @param {LAST_REFERENCES} LastReferences Справочники, из которых будет выполняться выбор
    * @return {WebAccess.components.wrappers.form.requisites._details.Reference} Объект типа Reference.
    * @since 5.2.0.1300
    */
    removeLastObjectsPseudoReference: function () {
      log.warning('REQUISITE', 'This method was changed in last version and may work improperly.');
      var me = this;
      me._addLastObjectsPseudoReference = false;
      me._lastReferences = null;
      if (me.isEditMode) {
        me._super();
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /** 
    * Установить значение отображаемых и неотображаемых реквизитов.    
    *
    * @function WebAccess.components.wrappers.form.requisites._details.Reference#setValues
    * @fires NOT_IMPLEMENTED_EXCEPTION
    * @param {object} newValues Новые значения множественного выбора
    * @param {boolean} needTriggerResult Вызвать триггер для события типа change
    * @return {WebAccess.components.wrappers.form.requisites._details.Reference} Текущий объект реквизита – Reference.
    * @since 5.0.0.7100
    */
    setValues: function (newValues, needTriggerResult) {
      WA.raise('NOT_IMPLEMENTED_EXCEPTION')
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает значения реквизита.
    * Формат записи метода: [{groupcode:'код справочника', id:'ид записи', name:'наименование'}, ...].
    *
    * @fires NOT_IMPLEMENTED_EXCEPTION
    * @function WWebAccess.components.wrappers.form.requisites._details.Reference#getValues
    * @return [{groupcode:'код справочника', id:'ид записи', name:'наименование'}, ...] Массив объектов значений реквизита – currentValues.
    * @since 5.4.0.1012
    */
    getValues: function () {
      WA.raise('NOT_IMPLEMENTED_EXCEPTION')
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавляет новые значения отображаемых и неотображаемых реквизитов к уже существующим.
    * Формат записи метода: [{groupcode:'код справочника', id:'ид записи', name:'наименование'}, ...].
    *
    * @fires NOT_IMPLEMENTED_EXCEPTION
    * @function WebAccess.components.wrappers.form.requisites._details.Reference#addValues
    * @param {object} newValues Новые значения множественного выбора
    * @param {boolean} needTriggerResult Вызвать триггер для события типа change
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Текущий объект реквизита – Reference.
    * @since 5.4.0.1012
    */
    addValues: function (newValues, needTriggerResult) {
      WA.raise('NOT_IMPLEMENTED_EXCEPTION')
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Привязка вызова справочника в модальном окне по клику на иконке в поле ввода.
    *
    * @method WebAccess.components.wrappers.form.requisites._details.Reference#bindReferenceGridDialog
    * @since 5.4.0.1012
    * @return {WebAccess.components.wrappers.form.requisites._details.Reference} Текущий объект реквизита – Reference.
    */
    bindReferenceGridDialog: function () {
      var me = this;
      me._bindReferenceGridDialog = true;
      if (me.isEditMode) {
        me._super();
      }
      return me;
    }
  });

  global._details.Reference = Reference;
})(window.WA.CMP.wrappers.form.requisites);